<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Принтеры M3250, MS622">
     Принтеры M3250, MS622
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ru" title="Информация по технике безопасности">
     Информация по технике безопасности
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Условные обозначения">
      Условные обозначения
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Заявление о продукте">
      Заявление о продукте
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ru" title="Информация о принтере">
     Информация о принтере
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ru" title="Поиск сведений о принтере">
      Поиск сведений о принтере
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_ru" title="Выбор местоположения принтера">
      Выбор местоположения принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_ru" title="Конфигурации принтера">
      Конфигурации принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_ru" title="Подключение кабелей">
      Подключение кабелей
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_ru" title="Использование панели управления">
      Использование панели управления
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_ru" title="Состояние кнопки и индикатора питания">
      Состояние кнопки и индикатора питания
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-network-setup-page-topic.html#printing-network-setup-page_ru" title="Печать страницы сетевых параметров">
      Печать страницы сетевых параметров
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ru" title="Установка и использование приложений начального экрана">
     Установка и использование приложений начального экрана
    </a>
   </p>
   <div id="divd0e746">
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_ru" title="Использование начального экрана">
      Использование начального экрана
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_ru" title="Настройка начального экрана">
      Настройка начального экрана
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_ru" title="Настройка дисплея">
      Настройка дисплея
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_ru" title="Настройка параметров экономичного режима">
      Настройка параметров экономичного режима
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_ru" title="Использование приложения Поддержка клиентов">
      Использование приложения Поддержка клиентов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_ru" title="Использование решения Генератор кода QR">
      Использование решения Генератор кода QR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_ru" title="Настройка квот устройства">
      Настройка квот устройства
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_ru" title="Создание профиля в Cloud Connector">
      Создание профиля в Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1092" title="Управление закладками">
      Управление закладками
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1169" title="Управление контактами">
      Управление контактами
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_ru" title="Настройка и использование функций специальных возможностей">
     Настройка и использование функций специальных возможностей
    </a>
   </p>
   <div id="divd0e1288">
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_ru" title="Активация голосового руководства">
      Активация голосового руководства
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_ru" title="Перемещение по экрану с использованием жестов">
      Перемещение по экрану с использованием жестов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_ru" title="Включение режима увеличения">
      Включение режима увеличения
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_ru" title="Регулировка темпа речи голосового руководства">
      Регулировка темпа речи голосового руководства
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_ru" title="Использование экранной клавиатуры">
      Использование экранной клавиатуры
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_ru" title="Включение голосовых паролей или PIN-кодов">
      Включение голосовых паролей или PIN-кодов
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_ru" title="Загрузка обычной и специальной бумаги">
     Загрузка обычной и специальной бумаги
    </a>
   </p>
   <div id="divd0e1493">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_ru" title="Задание формата и типа бумаги">
      Задание формата и типа бумаги
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_ru" title="Настройка параметров для формата бумаги Universal">
      Настройка параметров для формата бумаги Universal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_ru" title="Загрузка бумаги в лотки">
      Загрузка бумаги в лотки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_ru" title="Загрузка в многоцелевое устройство подачи">
      Загрузка в многоцелевое устройство подачи
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_ru" title="Связывание лотков">
      Связывание лотков
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_ru" title="Держатель бумаги">
     Держатель бумаги
    </a>
   </p>
   <div id="divd0e1660">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-goldfinger-topic.html#supported-paper-sizes-goldfinger_ru" title="Поддерживаемые форматы бумаги">
      Поддерживаемые форматы бумаги
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-goldfinger-topic.html#supported-paper-types-goldfinger_ru" title="Поддерживаемые типы бумаги">
      Поддерживаемые типы бумаги
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-goldfinger-topic.html#supported-paper-weights-goldfinger_ru" title="Поддерживаемая плотность бумаги">
      Поддерживаемая плотность бумаги
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_ru" title="Недопустимая бумага">
      Недопустимая бумага
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_ru" title="Использование бумаги из вторсырья">
      Использование бумаги из вторсырья
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ru" title="Печать">
     Печать
    </a>
   </p>
   <div id="divd0e2519">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_ru" title="Печать с компьютера">
      Печать с компьютера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2545" title="Печать с мобильного устройства">
      Печать с мобильного устройства
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_ru" title="Печать с флэш-накопителя">
      Печать с флэш-накопителя
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_ru" title="Поддерживаемые флэш-накопители и типы файлов">
      Поддерживаемые флэш-накопители и типы файлов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ru" title="Настройка конфиденциальных заданий">
      Настройка конфиденциальных заданий
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ru" title="Печать конфиденциальных и других отложенных заданий">
      Печать конфиденциальных и других отложенных заданий
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_ru" title="Печать из профиля в Cloud Connector">
      Печать из профиля в Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_ru" title="Печать списка образцов шрифтов">
      Печать списка образцов шрифтов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_ru" title="Печать списка каталогов">
      Печать списка каталогов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_ru" title="Отмена задания на печать">
      Отмена задания на печать
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_ru" title="Структура меню">
     Структура меню
    </a>
   </p>
   <div id="divd0e3055">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_ru" title="Карта меню">
      Карта меню
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3374" title="Устройство">
      Устройство
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e5220" title="Печать">
      Печать
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e6478" title="Бумага">
      Бумага
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e6740" title="Накопитель USB">
      Накопитель USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6961" title="Сеть/Порты">
      Сеть/Порты
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8751" title="Безопасность">
      Безопасность
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e9886" title="Отчеты">
      Отчеты
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_ru" title="Справка">
      Справка
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e10134" title="Поиск и устранение неисправностей">
      Поиск и устранение неисправностей
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_ru" title="Печать страницы настроек меню">
      Печать страницы настроек меню
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ru" title="Обеспечение безопасности принтера">
     Обеспечение безопасности принтера
    </a>
   </p>
   <div id="divd0e10186">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_ru" title="Расположение гнезда замка безопасности">
      Расположение гнезда замка безопасности
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ru" title="Очистка памяти принтера">
      Очистка памяти принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_ru" title="Очистка памяти жесткого диска принтера">
      Очистка памяти жесткого диска принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_ru" title="Шифрование жесткого диска принтера">
      Шифрование жесткого диска принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ru" title="Восстановление значений по умолчанию, заданных изготовителем">
      Восстановление значений по умолчанию, заданных изготовителем
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_ru" title="Заявление об энергозависимости">
      Заявление об энергозависимости
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ru" title="Обслуживание принтера">
     Обслуживание принтера
    </a>
   </p>
   <div id="divd0e10400">
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_ru" title="Настройка уведомлений по электронной почте">
      Настройка уведомлений по электронной почте
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_ru" title="Регулировка уровня громкости наушников по умолчанию">
      Регулировка уровня громкости наушников по умолчанию
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e10462" title="Сеть">
      Сеть
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_ru" title="Настройка печати через последовательный интерфейс (только в ОС Windows)">
      Настройка печати через последовательный интерфейс (только в ОС Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_ru" title="Чистка принтера">
      Чистка принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_ru" title="Заказ компонентов и расходных материалов">
      Заказ компонентов и расходных материалов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e11198" title="Замена деталей и расходных материалов">
      Замена деталей и расходных материалов
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e11342" title="Перемещение принтера">
      Перемещение принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e11398" title="Экономия энергии и бумаги">
      Экономия энергии и бумаги
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e11502" title="Утилизация">
      Утилизация
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_ru" title="Устранение замятий">
     Устранение замятий
    </a>
   </p>
   <div id="divd0e11535">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_ru" title="Предотвращение замятия материалов для печати">
      Предотвращение замятия материалов для печати
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_ru" title="Определение местоположения замятия">
      Определение местоположения замятия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_ru" title="Замятие бумаги за дверцей A">
      Замятие бумаги за дверцей A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_ru" title="Замятие бумаги в задней дверце">
      Замятие бумаги в задней дверце
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_ru" title="Замятие бумаги в стандартном приемном лотке">
      Замятие бумаги в стандартном приемном лотке
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_ru" title="Замятие бумаги в устройстве двусторонней печати">
      Замятие бумаги в устройстве двусторонней печати
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_ru" title="Замятие бумаги в лотках">
      Замятие бумаги в лотках
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_ru" title="Замятие в многоцелевом устройстве подачи">
      Замятие в многоцелевом устройстве подачи
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ru" title="Поиск и устранение неисправностей">
     Поиск и устранение неисправностей
    </a>
   </p>
   <div id="divd0e11811">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e11814" title="Проблемы с сетевым подключением">
      Проблемы с сетевым подключением
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e12128" title="Проблемы с аппаратной частью">
      Проблемы с аппаратной частью
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e12402" title="Проблемы с расходными материалами">
      Проблемы с расходными материалами
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_ru" title="Проблемы с подачей бумаги">
      Проблемы с подачей бумаги
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_ru" title="Проблемы с печатью">
      Проблемы с печатью
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ru" title="Обращение в службу технической поддержки">
      Обращение в службу технической поддержки
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_ru" title="Обновление и перемещения">
     Обновление и перемещения
    </a>
   </p>
   <div id="divd0e15394">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e15397" title="Оборудование">
      Оборудование
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e15707" title="Программное обеспечение">
      Программное обеспечение
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e15790" title="Микропрограммное обеспечение">
      Микропрограммное обеспечение
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ru" title="Уведомления">
     Уведомления
    </a>
   </p>
   <div id="divd0e15876">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15879" title="Информация о продукте">
      Информация о продукте
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15896" title="Уведомление о редакции">
      Уведомление о редакции
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ru" title="Товарные знаки">
      Товарные знаки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ru" title="Уведомления о лицензировании">
      Уведомления о лицензировании
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ru" title="Уровни шума">
      Уровни шума
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_ru" title="Инструкция по обращению с отходами электрического и электронного оборудования (WEEE)">
      Инструкция по обращению с отходами электрического и электронного оборудования (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16000" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ru" title="Утилизация изделий">
      Утилизация изделий
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16034" title="Литий-ионный аккумулятор">
      Литий-ионный аккумулятор
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_ru" title="Регламент (ЕС) 2023/1542">
      Регламент (ЕС) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_ru" title="Возврат картриджей Lexmark для повторного использования или утилизации">
      Возврат картриджей Lexmark для повторного использования или утилизации
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ru" title="Предупреждение о чувствительности к разрядам статического электричества">
      Предупреждение о чувствительности к разрядам статического электричества
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ru" title="Программа ENERGY STAR">
      Программа ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ru" title="Информация о температуре">
      Информация о температуре
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ru" title="Уведомление о лазерном излучении">
      Уведомление о лазерном излучении
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ru" title="Потребляемая мощность">
      Потребляемая мощность
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16274" title="Уведомления о соответствии стандартам для беспроводных устройств">
      Уведомления о соответствии стандартам для беспроводных устройств
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_ru" title="Уведомление о модульном компоненте">
      Уведомление о модульном компоненте
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ru" title="Воздействие радиочастотного излучения">
      Воздействие радиочастотного излучения
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16300" title="Соответствие директивам Европейского сообщества (EC)">
      Соответствие директивам Европейского сообщества (EC)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_ru" title="Соответствие директивам Европейского сообщества (EC)">
      Соответствие директивам Европейского сообщества (EC)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_ru" title="Уведомление о помехах радиосвязи">
      Уведомление о помехах радиосвязи
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue